// R3a implementer — DashboardPanel 모듈 (GREEN).
//
// 다크 톤 통계 패널 wrapper + (옵션) 헤더 슬롯. 디폴트 다크 (data-theme="dark"),
// theme="light" 인터페이스로 라이트 스코프 활성. 옵션 a (단일 모듈 + theme prop) +
// 옵션 2 변형 (title/controls 모두 optional, 둘 다 falsy 시 헤더 영역 자체 미렌더 — 위젯 모드).
//
// planner 명세 (DashboardPanel.test.jsx 인터페이스, plan 2026-05-09-r3a §3-4):
//   <DashboardPanel title="..." controls={...} theme="dark"|"light">
//     {children}
//   </DashboardPanel>
//
// PageShell 과의 차이 (책임 분리):
//   - PageShell  = 페이지 최상위 wrapper (h1, page-padding, 페이지당 1개)
//   - DashboardPanel = 패널 wrapper (h3, panel-padding, 페이지 안에 N개 또는 페이지 자체로 사용 가능)
//
// 외부 의존 0 (react-router-dom / 차트 / api / PageShell 등 직접 import 금지).

import React from 'react';
import './DashboardPanel.css';

const DashboardPanel = ({
  title = null,
  controls = null,
  theme = 'dark',
  children,
}) => {
  const hasHeader = Boolean(title) || Boolean(controls);
  return (
    <div className="dashboard-panel" data-theme={theme}>
      {hasHeader && (
        <div className="dashboard-panel__header">
          {title && <h3 className="dashboard-panel__title">{title}</h3>}
          {controls && (
            <div className="dashboard-panel__controls">{controls}</div>
          )}
        </div>
      )}
      <div className="dashboard-panel__body">{children}</div>
    </div>
  );
};

export default DashboardPanel;
